const appInfo = {
    title: 'BoxOn'
};
export default appInfo;

